import React, { useEffect, useRef, useState } from 'react';

import { CountryItemPanel } from 'apps/auth/components/common/components/CountryItemPanel/CountryItemPanel';
import { NotFoundResult } from 'apps/auth/components/common/search/NotFoundResult';
import { RESIDENT_COUNTRY } from 'apps/auth/constants/fieldsName';

import { SearchBar } from './components/SearchBar/SearchBar';

const CountryDropBoxList = (props) => {
    const searchRef = useRef(null);
    const [itemsList, setItems] = useState(props.items);
    const [searchCountry, setSearchCountry] = useState('');

    useEffect(() => {
        searchRef.current.focus();
    }, []);

    const search = (e) => {
        const term = e.target.value;
        const resultList = props.items.filter((item) => {
            return (
                term === undefined ||
                (item !== null && item.name !== null && item.name.toLowerCase().indexOf(term.toLowerCase()) >= 0) ||
                (item.synonym !== null && item.synonym.toLowerCase().indexOf(term.toLowerCase()) >= 0)
            );
        });
        setItems(resultList);
        setSearchCountry(term);
    };

    const easySearch = (e) => {
        const term = e.target.value;
        const resultList = props.items.filter((item) => {
            return term === undefined || (item !== null && item.name !== null && item.name.toLowerCase().indexOf(term.toLowerCase()) >= 0);
        });
        setItems(resultList);
        setSearchCountry(term);
    };

    const clearAddressFields = (fieldName, newCountrySelected) => {
        if (fieldName === RESIDENT_COUNTRY && newCountrySelected) {
            props.clearFieldsOnCountrySelect?.();
        }
    };

    return (
        <>
            <SearchBar
                placeholder={props.searchPlaceholder}
                onChange={props.isStrapiField ? easySearch : search}
                id={`search_field_${props.name}_${props.id}`}
                onCloseButtonClick={props.onCloseButtonClick}
                searchRef={searchRef}
            />

            {itemsList.length === 0 && <NotFoundResult notFoundMessage={props.searchDropBoxEmpty} />}
            {itemsList.length > 0 &&
                itemsList.map((item) => {
                    return (
                        <div key={`phone_countries_list_${item.code}`} id={`reg-country-${item.code}`}>
                            <CountryItemPanel
                                onClick={(e) => {
                                    props.selectItem(e, item);
                                    clearAddressFields(props.field?.name, props.field.value !== item.id);
                                }}
                                countryName={item.name}
                                flagIconName={item.code}
                                query={searchCountry}
                                isSelectedCountry={props.field.value === item.id}
                            />
                        </div>
                    );
                })}
        </>
    );
};
export default CountryDropBoxList;
